




















import Vue, { VNode } from 'vue';
import { SwExtendedVue } from '../sw-extended-vue';
import myUtilService from './util.service';

export default Vue.extend({
  name: 'SwTransitionExpand',
  functional: true,
  props: {
    direction: {
      type: String,
      default: 'vertical',
    },
    duration: {
      type: Number,
    },
    setOverflow: {
      type: Boolean,
      default: true,
    },
    appear: {
      type: Boolean,
      default: false,
    },
  },
  render(h, context): VNode {// tslint:disable-line
    const isVertical = context.props.direction === 'vertical';

    const mergedListeners = myUtilService.mergedHooks(
      {
        'before-enter': (el: HTMLElement) => {
          if (isVertical) {
            if (context.props.setOverflow) { el.style.overflowY = 'hidden'; }
          } else {
            if (context.props.setOverflow) { el.style.overflowX = 'hidden'; }
          }
          if (context.props.duration !== undefined) {
            el.style.transitionDuration = `${context.props.duration}ms`;
          }
        },
        enter: (el: HTMLElement) => {
          if (isVertical) {
            const height = Math.max(el.scrollHeight, el.firstElementChild ? (el.firstElementChild as HTMLElement).offsetHeight : 0);
            el.style.height = `${height}px`;
          } else {
            const width = Math.max(el.scrollWidth, el.firstElementChild ? (el.firstElementChild as HTMLElement).offsetWidth : 0);
            el.style.width = `${width}px`;
          }
        },
        'after-enter': (el: HTMLElement) => {
          if (isVertical) {
            el.style.height = '';
            if (context.props.setOverflow) { el.style.overflowY = ''; }
          } else {
            el.style.width = '';
            if (context.props.setOverflow) { el.style.overflowX = ''; }
          }
          el.style.transitionDuration = '';
        },
        'before-leave': (el: HTMLElement) => {
          if (isVertical) {
            if (!el.style.height) {
              el.style.height = `${el.offsetHeight}px`;
            }
            if (context.props.setOverflow) { el.style.overflowY = 'hidden'; }
          } else {
            if (!el.style.width) {
              el.style.width = `${el.offsetWidth}px`;
            }
            if (context.props.setOverflow) { el.style.overflowX = 'hidden'; }
          }
          if (context.props.duration !== undefined) {
            el.style.transitionDuration = `${context.props.duration}ms`;
          }
        },
        leave: () => {},
        'after-leave': (el: HTMLElement) => {
          if (isVertical) {
            el.style.height = '';
            if (context.props.setOverflow) { el.style.overflowY = ''; }
          } else {
            el.style.width = '';
            if (context.props.setOverflow) { el.style.overflowX = ''; }
          }
          el.style.transitionDuration = '';
        },
      },
      context.listeners,
    );

    return (
      <transition
        name={isVertical ? 'sw-transition-expand-vertical' : 'sw-transition-expand-horizontal'}
        {...{
          on: mergedListeners,
        }}
        appear={context.props.appear}
      >
      {context.children}
      </transition>
    ) as VNode;
  },
}) as typeof SwExtendedVue;
